<template>
  <main class="pp-page--login">
    <h1 class="title title--desktop">{{ $t("account.login") }}</h1>
    <div class="pp-layout-container pp-layout-container--single">
      <div class="pp-preamble">
        <h1 class="title title--mobile">{{ $t("account.login") }}</h1>
      </div>
      <section class="pp-main-content">
        <button class="btn--inverted" @click="goToLogin">{{ $t("account.login") }}</button>
      </section>
    </div>
  </main>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "login",
  mounted() {
    this.scrollToTopOfPurchasePath();
    this.updateLoading(false);
    this.updateStage("login");
  },
  methods: {
    goToLogin() {
      let backend = process.env.VUE_APP_WK_INTEGRATION_LAYER;

      let currentUrl = window.location.protocol + "//" + window.location.host;
      let loginUrl =
        backend + "/ciam/oauth/check?redirect=" + currentUrl + "/" + this.$i18n.locale + "/cart&language=" + this.$i18n.locale;
      window.location.href = loginUrl;
    },
    ...mapActions(["updateLoading", "updateStage", "scrollToTopOfPurchasePath"]),
  },
};
</script>